// Beta — quién ve y usa KIQ (panel, chat, página /kiq): admin y gerente. Es el MISMO
// criterio que el backend (requireRol('admin', 'gerente') en backend/routes/kiq.js,
// SH-2), que es la autoridad: esto solo evita ofrecer a cajero y cocinero una
// sección que el servidor rechazaría. Sin usuario o rol conocido → no.
export const ROLES_KIQ = Object.freeze(['admin', 'gerente']);

export const puedeUsarKIQ = (rol) => ROLES_KIQ.includes(rol);
